export default "__VITE_ASSET__fdb2a619__"